export default __webpack_public_path__ + "static/media/chart1.922e8223.svg";